






































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

import PersonForm from '../../PersonForm/PersonForm.vue';
import DeliveryPointForm from '../../DeliveryPointForm/DeliveryPointForm.vue';
import CounterpartyForm from '../../CounterpartyForm/CounterpartyForm.vue';

export const CONTACTS_LIST = 'CONTACTS_LIST';
export const DELIVERY_POINT_LIST = 'DELIVERY_POINT_LIST';
export const COUNTERPARTIE_LIST = 'COUNTERPARTIE_LIST';

@Component
export default class ClientProps extends Vue {

  @Prop() clientId!: string;

  contacts = [];
  filteredContacts = [];
  contactsLoading = false;
  acrhived_contacts_show = false;

  deliveryPoints = [];
  filteredDeliveryPoints = [];
  deliveryPointsLoading = false;

  counterparties = [];
  filteredCounterparties = [];
  counterpartiesLoading = false;

  loadContactsData() {
    this.contactsLoading = true;

    (this as any).$db([
      (this as any).$q(CONTACTS_LIST)
        .select()
        .fileds({
            id: `people.id`,
            name: `people.name`,
            position: `people.position`,
            contacts: `people.contacts`,
            role: `people.role`,
            archived_at: `people.archived_at`,
        })
        .from('people')
        .limit(1000)
        .where((_: any) => {
          return _.eq(`people.client_id`, _.const(this.clientId));
        })
    ]).then((result: ServerResult) => {
      const opResult = result.getOperation(CONTACTS_LIST).getContent()
      const meta = fetchEnumsFromSchema(opResult.schema);

      this.contacts = opResult.documents.map((document: any) => {
        return {
          id: document.id,
          name: document.name,
          position: document.position,
          role: meta.role.choices[document.role],
          primary_phone: document.contacts.find((contact: any) => contact.is_primary && contact.type == 'phone'),
          primary_email: document.contacts.find((contact: any) => contact.is_primary && contact.type == 'email'),
          archived_at: document.archived_at,
        }
      });

      this.filterContact(this.acrhived_contacts_show)

    }).finally(() => {
      this.contactsLoading = false;
    });
  }

  loadDeliveryPoints() {
    this.deliveryPointsLoading = true;

    (this as any).$db([
      (this as any).$q(DELIVERY_POINT_LIST)
        .select()
        .fileds({
            id: `delivery_points.id`,
            city_name: `cities.name`,
            address: `delivery_points.address`,
            address_to_wa: `delivery_points.address_to_wa`,
            phone: `delivery_points.phone`,
            comment: `delivery_points.comment`,
            archived_at: `delivery_points.archived_at`,
        })
        .from('delivery_points')
        .innerJoin('cities', (_: any) => {
          return _.eq('cities.id', 'delivery_points.city_id');
        })
        .limit(1000)
        .where((_: any) => {
          return _.eq(`delivery_points.client_id`, _.const(this.clientId));
        })
    ]).then((result: ServerResult) => {
      const opResult = result.getOperation(DELIVERY_POINT_LIST).getContent()
      const meta = fetchEnumsFromSchema(opResult.schema);

      this.deliveryPoints = opResult.documents
      this.filterDeliveryPoints(false)
    }).finally(() => {
      this.deliveryPointsLoading = false;
    });
  }

  filterDeliveryPoints($event: any) {
    this.filteredDeliveryPoints = this.deliveryPoints.filter((item: any) => {
      console.log(item)
        return $event || !item.archived_at ? item : null
      })
  }

  filterContact($event: any) {
    this.acrhived_contacts_show = $event;
    this.filteredContacts = this.contacts.filter((item: any) => {
      console.log(item)
        return this.acrhived_contacts_show || !item.archived_at ? item : null
      })
  }

  filterCounterparties($event: any) {
    this.filteredCounterparties = this.counterparties.filter((item: any) => {
      console.log(item)
        return $event || !item.archived_at ? item : null
      })
  }

  loadСounterparties() {
    this.counterpartiesLoading = true;

    (this as any).$db([
      (this as any).$q(COUNTERPARTIE_LIST)
        .select()
        .fileds({
            id: `counterparties.id`,
            name: `counterparties.name`,
            inn: `counterparties.inn`,
            kpp: `counterparties.kpp`,
            archived_at: `counterparties.archived_at`,
        })
        .from('counterparties')
        .limit(1000)
        .where((_: any) => {
          return _.eq(`counterparties.client_id`, _.const(this.clientId));
        })
    ]).then((result: ServerResult) => {
      // console.log(result.getOperation(COUNTERPARTIE_LIST).getContent())
      const opResult = result.getOperation(COUNTERPARTIE_LIST).getContent()
      const meta = fetchEnumsFromSchema(opResult.schema);

      this.counterparties = opResult.documents
      this.filterCounterparties(false)

      // console.log('this.documents', this.documents, opResult.documents)
    }).finally(() => {
      this.counterpartiesLoading = false;
    });
  }

  // ---------------------------------------------------------------------------

  openContact(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: PersonForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          client_id: this.clientId
        }
      },
      events: {
        'form-close': () => {
          this.loadContactsData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  openDeliveryPoint(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: DeliveryPointForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          client_id: this.clientId
        }
      },
      events: {
        'form-close': () => {
          this.loadDeliveryPoints();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openCounterparty(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: CounterpartyForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          client_id: this.clientId
        }
      },
      events: {
        'form-close': () => {
          this.loadСounterparties();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadContactsData();
    this.loadDeliveryPoints();
    this.loadСounterparties();
  }
}

